import * as consultationApi from './consultation'
import * as reviewApi from './review'

const api = {
  consultation: {
    ...consultationApi,
  },
  review: {
    ...reviewApi,
  },
}

export default api
